export default {
  title: {
    id: 'bo_seller.kyb.stepper.title',
    defaultMessage: 'To complete',
  },
  reviewStepLabel: {
    id: 'bo_seller.kyb.stepper.review_step_label',
    defaultMessage: 'Review & submit',
  },
} as const
